import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(() => ({
  // Single-line clip with a width-based ellipsis. `minWidth: 0` lets it shrink
  // inside a flex row so the ellipsis actually kicks in. LabraToolTipV2 wraps the
  // text in its own <div>; force it inline so this element's text-overflow
  // ellipsis still applies to the text inside it.
  clip: {
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& > div': {
      display: 'inline',
    },
  },
}))
